import type { TimelineItemType } from '@witmetrics/unison-core';
import { useLocalStorage } from '@/hooks/useStorage';

export const classes = {
  card: 'flex flex-col min-h-0 bg-gradient-to-br from-white to-orange-300/40 via-orange-100/20 from-30% px-0 dark:bg-none dark:bg-white/[0.04]',
  titleBlock: 'place-between mb-4 shrink-0 px-6',
  title: 'font-medium text-base text-grey-9 dark:text-mauve-1',
  message: 'mt-4 text-center text-grey-6 dark:text-mauve-3 text-base',
  timeline: 'flex-1 min-h-0 overflow-y-auto px-6',
  fieldWrapper: 'px-6',
  field: 'border border-grey-3 dark:border-white/10',
};

export function useTimelineSettings(initialSettings?: TimelineItemType) {
  return useLocalStorage('timelineSettings', initialSettings || 'ALL', true);
}
